import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  footer: {
    height: "70px",
    "& span": {
      color: "rgb(var(--gray))",
      fontSize: "12px",
      opacity: "0.70",
      lineHeight: "14px",
      fontWeight: "var(--fw-500)",
    },
  },
});
